import React from 'react';

import { PlayButton } from './PlayButton';
import { PauseButton } from './PauseButton';

interface Props {
    addClasses?: string;
    width?: number;
    isPlaying: boolean;
    handleClick(): void;
}

export const PlayPauseButton = ({
    addClasses,
    width,
    isPlaying,
    handleClick,
}: Props): JSX.Element => {
    if (!isPlaying) {
        return (
            <PlayButton
                addClasses={addClasses}
                gradientColor="secondary"
                handleClick={handleClick}
                iconColor="secondary-500"
                width={width}
            />
        );
    }

    return (
        <PauseButton
            addClasses={addClasses}
            gradientColor="quarternary"
            handleClick={handleClick}
            iconColor="quarternary-500"
            width={width}
        />
    );
};
